import { mapGetters } from "vuex"

export default {
    name: "GuidesHero",
    props: {},
    emits: [],
    components: {},
    setup() {},
    data() {
        return {}
    },
    created() {},
    mounted() {},
    watch: {},
    computed: {
        ...mapGetters({
            content: "guides/content",
        })
    },
    methods: {}
}
